<template>
  <div
    id="engagementsList"
    class="mainCard"
  >
    <div class="header mainCard">
      <div class="searchWrap">
        <el-row
          class="searchTools"
          style="width: 100%; flex-wrap: wrap;"
          type="flex"
          justify="space-between"
          :gutter="8"
        >
          <el-col :span="8">
            <div class="selectWrap">
              <div class="searchTitle defaultCursor">
                {{ $t('common.sortBy') }}
              </div>
              <el-select
                v-model="sortOrder"
                :placeholder="$t('common.search')"
                class="searchSelect"
              >
                <el-option
                  v-for="item in sortOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="selectWrap">
              <div class="searchTitle defaultCursor">
                {{ $t('common.filterBy') }}
              </div>
              <el-select
                v-model="selectedFilter"
                :placeholder="$t('common.search')"
                class="searchSelect"
              >
                <el-option
                  v-for="item in filterOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="inputWrap">
              <el-input
                v-model="searchInput"
                class="clearInput searchText"
                suffix-icon="el-icon-search"
                clearable
                :placeholder="$t('common.search')"
              />
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div v-if="engagements.length > 0">
      <div
        v-for="(engagement, key) in formattedEngagements"
        :key="key"
        class="engagementItem"
        @click="goToDetails(engagement)"
      >
        <EngagementSummary :engagement="engagement" />
      </div>
    </div>

    <div
      v-else
      v-loading="loading"
    >
      <div class="noData">
        <span v-if="!loading">
          {{ $t('coach.engagements.noData') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import EngagementSummary from './components/EngagementSummary.vue';

export default {
  name: 'EngagementsList',

  components: {
    EngagementSummary,
  },

  data() {
    return {
      loading: true,
      engagements: [],
      sortOptions: [
        { value: 'durationAsc', label: this.$t('coach.sort.durationAsc') },
        { value: 'durationDesc', label: this.$t('coach.sort.durationDesc') },
        { value: 'nameAsc', label: this.$t('coach.sort.nameAsc') },
        { value: 'nameDesc', label: this.$t('coach.sort.nameDesc') },
      ],
      filterOptions: [
        { value: 'all', label: this.$t('coach.filter.leaderAll') },
        { value: 'gcg', label: this.$t('coach.filter.engagementGcg') },
        { value: 'invited', label: this.$t('coach.filter.leaderInvited') },
      ],
      sortOrder: 'nameAsc',
      selectedFilter: 'all',
      searchInput: '',
    };
  },

  computed: {
    formattedEngagements() {
      const { engagements } = this;

      const list = engagements
        .filter((el) => {
          // filter option = all, gcg, invited, pending
          let filter = true;
          if (this.searchInput !== '') {
            filter = el.leader_info.name.toUpperCase().includes(this.searchInput.toUpperCase())
                || el.leader_info.email.toUpperCase().includes(this.searchInput.toUpperCase());
          }
          if (this.selectedFilter === 'gcg') {
            filter = !el.is_invited;
          }
          if (this.selectedFilter === 'invited') {
            filter = el.is_invited;
          }
          if (this.selectedFilter === 'pending') {
            filter = false;
          }
          return filter;
        }).sort((a, b) => {
          switch (this.sortOrder) {
            case 'durationAsc':
              return a.duration - b.duration;
            case 'durationDesc':
              return b.duration - a.duration;
            case 'nameAsc':
              return a.leader_info.name > b.leader_info.name ? 1 : -1;
            case 'nameDesc':
              return a.leader_info.name < b.leader_info.name ? 1 : -1;
            default:
              return 0;
          }
        });

      return list;
    },
  },

  created() {
    this.getEngagements();
  },

  methods: {
    goToDetails(engagement) {
      this.$router.push({
        name: 'leaderEngagementDetails',
        params: { id: engagement.uuid },
      });
    },

    async getEngagements() {
      try {
        this.loading = true;
        const response = await api.getEngagements({ status: 'completed' });
        this.engagements = response.data.results;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
#engagementsList {
  padding-top: 30px;

  .searchWrap {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 20px;
    color: var(--themeFontColor);

    .el-select .el-input__inner {
      border-radius: 20px;
      background-color: transparent;
      color: var(--themeFontColor);
    }

    .searchTools {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      width: calc(100% - 75px);

      .selectWrap {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .searchTitle {
          font-weight: bold;
          padding-right: 10px;
          box-sizing: border-box;
          width: 80px;
        }
      }

      .inputWrap {
        width: 100%;
        text-align: right;

        .searchText {
          max-width: 250px;
        }
      }

      .searchText.el-input {
        border-bottom: 1px solid var(--themeFontColor);
        width: 100%;
      }
    }
  }

  .engagementItem {
    margin-bottom: 15px;
    cursor: pointer;
  }

  .noData {
    margin-top: 40px;
    padding: 30px 0;
    background-color: var(--themeCardColor);
    border-radius: 10px;
    color: var(--themeFontColor);
    text-align: center;
  }
}
</style>
